import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {ShareddataService} from '../../../../shared/services/shareddata.service';
import * as moment from 'moment';
import {I18nService} from '../../../../shared/services/i18n.service';
import {MatTableDataSource} from '@angular/material/table';
import {MatSort} from '@angular/material/sort';
import {MatPaginator} from '@angular/material/paginator';
import {JsonArrayResponseInterface, ToolInterface} from '../../../../models/sharedinterface';
import {HttpClient} from '@angular/common/http';
import {BehaviorSubject} from 'rxjs';

@Component({
  selector: 'app-generic-orders-list',
  templateUrl: './generic-orders-list.component.html',
  styleUrls: ['./generic-orders-list.component.scss']
})
export class GenericOrdersListComponent implements OnInit {

  public filterObject: {
    filtervalue: string;
  } = {
    filtervalue: '',
  };

  public currentOrder: any;

  @Input() currentOrderListTool$: BehaviorSubject<ToolInterface> = new BehaviorSubject<ToolInterface>(null);
  currentOrderListTool: ToolInterface;

  datalistsource: MatTableDataSource<any>; // MatTableDataSource
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;

  // export options
  public exportOptions = {
    fileName: 'Orders export',
    sheet: this.i18n.get('orders_export_sheetname', 'orders'),
  };

  displayedColumns: any = [];
  keyColumns: any = []; // Columns with link

  constructor(private sharedData: ShareddataService,
              public i18n: I18nService,
              private http: HttpClient) {
    this.currentOrder = null;
  }

  ngOnInit(): void {

    this.currentOrderListTool$.subscribe(currentOrderListTool => {
      this.currentOrderListTool = currentOrderListTool;
      this.loadListData();
    });

    this.displayedColumns = ['ordernr', 'orderdate', 'username', 'actions'];
    this.keyColumns = ['id'];

    // Subscribe for the list data of the tool
    this.sharedData.toolOrderListData$.subscribe( data => {
      this.datalistsource = new MatTableDataSource(data);
      this.datalistsource.sort = this.sort;
      this.datalistsource.paginator = this.paginator;
      this.onDataSourceReady();
    });
  }

  loadListData() {
    this.datalistsource = undefined;

    // Refresh the list of data from tool endpoint
    const language = this.sharedData.getCurrentlanguage();
    const mandant = this.sharedData.getMandantLabel();
    const url = this.currentOrderListTool.orderlistapi + '?mandant=' + mandant + '&languageKey=' + language.key;
    this.http.get<JsonArrayResponseInterface>(url).subscribe( data => {
      this.sharedData.setToolOrderListData(data.results);
    } );

  }

  onDataSourceReady() {
    this.datalistsource.sortingDataAccessor = (item, property) => {
      switch (property) {
        case 'date':
          return new Date(item.date.date);
        default:
          return item[property];
      }
    };
    this.datalistsource.filterPredicate = this.filterPredicateHandler.bind(this);
  }

  applyFilter($event?: Event) {
    console.log($event);
    this.datalistsource.filter = JSON.stringify(this.filterObject);
  }

  filterPredicateHandler(inputData, filter: string): boolean {

    const filterObject = JSON.parse(filter);

    // Global text filtering
    let textCriteria = true;
    if (filterObject?.filtervalue !== '') {
      const nrCriteria = this.containsLowercaseFilter(inputData.ordernr, filterObject.filtervalue);
      const orderDateCriteria = this.containsLowercaseFilter(inputData.orderdate, filterObject.filtervalue);
      const orderUsernameCriteria = this.containsLowercaseFilter(inputData.username, filterObject.filtervalue);
      const orderEmailCriteria = this.containsLowercaseFilter(inputData.useremail, filterObject.filtervalue);

      textCriteria = nrCriteria || orderDateCriteria || orderUsernameCriteria || orderEmailCriteria;
    }

    const filteredIn = textCriteria;

    return filteredIn;
  }

  containsLowercaseFilter(data: any, filter: string) {
    data = String(data);
    const treatedfilter = filter.trim().toLowerCase();
    const treateddata = data.trim().toLowerCase();

    const searchresult = treateddata.search(treatedfilter);
    if (searchresult === -1) { // No match
      return false;
    } // if
    return true;
  }

  getColumnLabel(fieldName: string) {
    switch (fieldName) {
      case 'ordernr':
        return 'Order Nr.';
      case 'orderdate':
        return 'Order date';
      case 'username':
        return 'Ordered by';
      case 'actions':
        return '';
      default:
        return fieldName;
    }
  }

  getFormattedValue(fieldName: string, value: any) {
    if (fieldName === 'orderdate') {
      // return moment(value.date).format('DD/MM/YYYY HH:mm');
      return moment(value).format('DD/MM/YYYY HH:mm');
    }
    return value;
  }



  openDetails(order) {
    this.currentOrder = order;
  }

  backToListData() {
    this.loadListData();
    this.currentOrder = null;
  }

}
